import { Action } from 'redux';
import {
	MissingProductItem,
	GalleryItem,
	ProductInfo,
	ShoppingGalleryItem,
} from 'sofa-reborn-react';
import { ProductData } from '@ikea-aoa/component-view-3d';

// State
export interface ProductsState {
	productInfo: ProductInfo | null;
	products: ProductData;
	missingProducts: MissingProductItem[];
	galleryItems: GalleryItem[];
	fetchConfigPending: boolean;
	galleryShoppingProducts: ShoppingGalleryItem[];
}

// Actions
export const FETCH_CONFIG_PENDING = 'FETCH_CONFIG_PENDING';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_FAILURE = 'FETCH_CONFIG_FAILURE';

interface FetchConfigPending extends Action {
	type: typeof FETCH_CONFIG_PENDING;
}

interface FetchConfigSuccess extends Action {
	type: typeof FETCH_CONFIG_SUCCESS;
	productInfo: ProductInfo | null;
	products: ProductData;
	galleryItems: GalleryItem[];
	missingProducts: MissingProductItem[];
	galleryShoppingProducts: ShoppingGalleryItem[];
}

interface FetchConfigFailure extends Action {
	type: typeof FETCH_CONFIG_FAILURE;
	message: string;
}

export type ProductsStateActions = FetchConfigPending | FetchConfigSuccess | FetchConfigFailure;
